export default __webpack_public_path__ + "static/media/gallery-1.fc290ee2.jpeg";